import { Alert, Form, Input, message, Modal, Spin } from "@ezviz/ezd";
import React, { useState } from "react";
import ExclamationCircleFilled from "./_components/_icons/ExclamationCircleFilled";
import ExperienceGoldIcon from "./_components/_icons/ExperienceGoldIcon";
import ExperiencingProducts from "./_components/ExperiencingProducts";
import "./index.less";
import PurchaseIcon from "./_components/_icons/PurchaseIcon";
import RightIcon from "./_components/_icons/RightIcon";
import FetchData from "@ezviz/FetchData";
import Cookies from "js-cookie";
import { processData } from "./_utils/experiencingProductForm";

const Activity = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [form] = Form.useForm();
  const key = "updatable";

  //#region 点击Modal的确认按钮
  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      const res = await form.validateFields();
      const data = processData(res.experiencingProducts);
      data.wantScene = res.achieved;
      data.phone = phone;

      const formData = new URLSearchParams();
      for (const key in data) {
        formData.append(key, data[key]);
      }

      const fetchData = new FetchData("/web/console/trial/v2/money/apply", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          csrftoken: Cookies.get("csrftoken"),
        },
        method: "POST",
        body: formData.toString(),
      });

      fetchData
        .then((res) => {
          if (res.meta && res.meta.code === 200) {
            setOpen(false);
            message.success({
              type: "success",
              content: (
                <span className="success">
                  领取成功，请前往
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#407aff",
                    }}
                    className="link"
                    onClick={() =>
                      (window.location.href = "/console/enterprise.html")
                    }
                  >
                    选择产品
                  </span>
                  进行体验（3s）
                </span>
              ),
              style: {
                position: "fixed",
                inset: "0",
                marginTop: "100px",
              },
              key,
              duration: 0,
            });
            let countdown = 3; // 初始化倒计时
            const interval = setInterval(() => {
              countdown -= 1; // 倒计时每秒减少
              // 更新 message 的内容
              message.success({
                type: "success",
                content: (
                  <span className="success">
                    领取成功，请前往
                    <span
                      style={{
                        cursor: "pointer",
                        color: "#407aff",
                      }}
                      className="link"
                      onClick={() =>
                        (window.location.href = "/console/enterprise.html")
                      }
                    >
                      选择产品
                    </span>
                    进行体验（{countdown}s）
                  </span>
                ),
                style: {
                  position: "fixed",
                  inset: "0",
                  marginTop: "100px",
                },
                key,
                duration: 0,
              });

              if (countdown <= 0) {
                clearInterval(interval);
                // 倒计时结束后跳转页面
                window.location.href = "/console/enterprise.html";
              }
            }, 1000);
          } else {
            message.error({
              type: "error",
              content: res.meta.message
                ? res.meta.message
                : "领取体验金失败，请稍后重试",
              style: {
                position: "fixed",
                inset: "0",
                marginTop: "100px",
              },
            });
          }
          setConfirmLoading(false);
        })
        .catch((err) => {
          setConfirmLoading(false);

          message.error({
            type: "error",

            content: "领取体验金失败，请稍后重试",
            style: {
              position: "fixed",
              inset: "0",
              marginTop: "100px",
            },
          });
        });
    } catch (err) {
      setConfirmLoading(false);
    }
  };
  //#endregion

  /** 0：可以申请体验金
   * 1.未登录
   * 2.未进行企业认证
   * 3.已领取体验金
   */
  //#region 查询企业体验金状态
  const checkStatus = async () => {
    const fetchData = new FetchData("/web/console/trial/v2/status/query", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        csrftoken: Cookies.get("csrftoken"),
      },
      method: "POST",
    });

    return fetchData
      .then((res) => {
        if (res.meta && res.meta.code === 200) {
          if (res.data === "1") {
            // 1.未登录
            message.warn({
              type: "warning",
              content: "请登录后再领取体验金",
              style: {
                position: "fixed",
                inset: "0",
                marginTop: "100px",
              },
            });

            window.location.href = "/console/login.html";
            return false;
          }

          if (res.data === "2") {
            Modal.confirm({
              title: (
                <span className="modalConfirmTitle">
                  该账号尚未进行企业认证，请前往进行企业认证，认证后可领取体验金用于各类服务。
                </span>
              ),
              centered: true,
              maskClosable: true,
              okText: "去认证",
              cancelText: "取消",
              onOk: () => {
                window.location.href = "/console/account.html";
              },
            });
            return false;
          } else if (res.data === "3") {
            message.warn({
              type: "warning",
              content: "您已领取，若需其他支持请联系我们",
              style: {
                position: "fixed",
                inset: "0",
                marginTop: "100px",
              },
            });
            return false;
          } else {
            return true;
          }
        } else if (res.meta && res.meta.code === "401") {
          message.warn({
            type: "warning",
            content: "请登录后再领取体验金",
            style: {
              position: "fixed",
              inset: "0",
              marginTop: "100px",
            },
          });
          window.location.href = "/console/login.html";
          return false;
        } else {
          message.error({
            type: "error",
            content: res.meta.message
              ? res.meta.message
              : "领取体验金失败，请稍后重试",
            style: {
              position: "fixed",
              inset: "0",
              marginTop: "100px",
            },
          });
          return false;
        }
      })
      .catch((error) => {
        message.error({
          type: "error",
          content: "领取体验金失败，请稍后重试",
          style: {
            position: "fixed",
            inset: "0",
            marginTop: "100px",
          },
        });
        return false;
      });
  };
  //#endregion

  //#region 请求用户数据并回填领取账户
  const requestUserData = async () => {
    const fetchData = new FetchData("/web/console/user/info", {
      headers: {
        csrftoken: Cookies.get("csrftoken"),
      },
      method: "GET",
    });

    return fetchData
      .then((res) => {
        if (res.meta && res.meta.code === 200) {
          const phone = res.data.authPhone;
          setPhone(phone);
          return {
            account: phone.substring(0, 3) + "****" + phone.substring(7),
            success: true,
          };
        } else {
          message.error({
            type: "error",
            content: res.meta.message
              ? res.meta.message
              : "领取体验金失败，请稍后重试",
            style: {
              position: "fixed",
              inset: "0",
              marginTop: "100px",
            },
          });
          return {
            account: null,
            success: false,
          };
        }
      })
      .catch((error) => {
        message.error({
          type: "error",
          content: "领取体验金失败，请稍后重试",
          style: {
            position: "fixed",
            inset: "0",
            marginTop: "100px",
          },
        });
        return {
          account: null,
          success: false,
        };
      });
  };

  //#endregion

  //#region 点击体验金领取操作项
  const handleClickExperienceGold = async () => {
    setLoading(true);

    const res = await checkStatus(); // 查询企业体验金状态
    if (res) {
      const userData = await requestUserData(); // 请求用户数据并回填领取账户
      if (userData.success) {
        form.setFieldsValue({
          account: userData.account,
        });
        setOpen(true);
      }
    }
    setLoading(false);
  };
  //#endregion

  return (
    <div className="cn_activity_container">
      <div className="popoverContainer">
        <Spin spinning={loading}>
          <div className="popoverContent" onClick={handleClickExperienceGold}>
            <div className="popoverItem">
              <div className="popoverIconContainer">
                <ExperienceGoldIcon className="popoverLeftIcon" />
              </div>
              <div>
                <p className="popoverTitle">新客专享券</p>
                <p className="popoverDesc">领取专享券体验各项服务</p>
              </div>
            </div>
            <RightIcon className="popoverIcon" />
          </div>
        </Spin>

        <a
          href="https://mp.weixin.qq.com/s/WjKrgWBuVqoBBpitj3kjWA"
          target="_blank"
          rel="noreferrer"
        >
          <div className="popoverContent">
            <div className="popoverItem">
              <div className="popoverIconContainer">
                <PurchaseIcon className="popoverLeftIcon" />
              </div>
              <div>
                <p className="popoverTitle">设备采购</p>
                <p className="popoverDesc">买设备送无门槛消费券</p>
              </div>
            </div>
            <RightIcon className="popoverIcon" />
          </div>
        </a>
      </div>

      <Modal
        className="cn_activity_customModal"
        title="体验金领取"
        visible={open}
        centered
        destroyOnClose
        maskClosable
        width={500}
        cancelText="取消"
        okText="立即申请"
        onOk={handleOk}
        onCancel={() => setOpen(false)}
        afterClose={() => form.resetFields()}
        zIndex={1000}
        bodyStyle={{
          overflowX: "hidden",
          overflowY: "auto",
          maxHeight: "700px",
        }}
        confirmLoading={confirmLoading}
      >
        <Alert
          style={{ marginBottom: "24px" }}
          icon={<ExclamationCircleFilled className="icon" />}
          message={
            <span className="message">
              企业认证账号专属，可领取新人专享150元无门槛消费券，学习和实践各种增值服务！
            </span>
          }
          type="info"
          showIcon
        />

        <Form form={form} layout="vertical">
          <Form.Item
            name="account"
            label="申领账号"
            rules={[{ required: true, message: "请输入申领账号" }]}
          >
            <Input disabled maxLength={500} />
          </Form.Item>

          <Form.Item
            label="希望体验的产品"
            name="experiencingProducts"
            rules={[
              {
                validator(_, value, callback) {
                  if (!value) {
                    callback("请选择至少一项产品");
                  }
                  if (value.other && value.other.trim().length < 5) {
                    callback("请输入至少5个字符");
                  }
                  if (
                    (!value.other || value.other.trim().length === 0) &&
                    ["access", "ai", "message", "pullCurrent", "storage"].every(
                      (array) => value[array].length === 0 || !value[array]
                    )
                  ) {
                    callback("请选择至少一项产品");
                  } else {
                    callback();
                  }
                },
              },
            ]}
          >
            <ExperiencingProducts />
          </Form.Item>

          <Form.Item
            name="achieved"
            label="想要实现的场景"
            rules={[
              { required: true, message: "请输入想要实现的场景" },
              {
                min: 20,
                message: "请输入至少20个字符",
              },
            ]}
          >
            <Input.TextArea
              className="textarea"
              style={{
                minHeight: 120,
                maxHeight: 260,
              }}
              placeholder="参考描述：在**行业，需要实现*****，查看***情况，做****处理。"
              showCount
              maxLength={500}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Activity;
